// extracted by mini-css-extract-plugin
export default {"addGradeSwitch":"pointSliderForm_addGradeSwitch__GsWV7"};